module.exports = __webpack_public_path__ + "img/11.cdc6569b.png";